import { Stack, styled } from '@mui/material'

export const QuickViewBox = styled(Stack)(({ theme }) => ({
    height: '110px',
    borderRadius: '12px',
    border: `1px solid ${theme.palette.customtext.black23}`,
    overflow: 'hidden',
}))
